import React, { useEffect, useState } from 'react';
import { publisherSelfAPI as publisherAPI, packageAPI, bookAPI, projectAPI } from '../../utils/api';
import Swal from 'sweetalert2';
import '../workorders/css/workorderModal.css';

export default function PublisherWorkorderPage() {
  const [rows, setRows] = useState([]);
  const [packages, setPackages] = useState([]);
  const [books, setBooks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [viewRow, setViewRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [wo, pkg, bk, pr] = await Promise.all([
        publisherAPI.getWorkOrders(),
        packageAPI.getAll(),
        bookAPI.getAll(),
        projectAPI.getAll(),
      ]);
      // Exclude draft status
      const workOrders = (wo.data || []).filter(r => r.status !== 'DRAFT');
      setRows(workOrders);
      setPackages(pkg.data || []);
      setBooks(bk.data || []);
      setProjects(Array.isArray(pr.data) ? pr.data : pr.data?.content || []);
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Load error', text: e.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const nf = new Intl.NumberFormat('en-US');
  const fetchDetail = async (id) => {
    try {
      const res = await publisherAPI.getWorkOrder(id);
      setViewRow(res.data);
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Load error', text: e.message });
    }
  };

  return (
    <div className="eduss-student-table">
      <div className="eduss-global-table-header">
        <div className="eduss-global-table-title">
          <h2>Work Orders</h2>
          <p>Your issued purchase orders</p>
        </div>
      </div>

      <div className="eduss-global-datatable-container" style={{ marginTop: 12 }}>
        <table className="eduss-global-datatable">
          <thead>
            <tr>
              <th>Project</th>
              <th>Order #</th>
              <th>Order Date</th>
              <th>Package</th>
              <th>Status</th>
              <th>Qty</th>
              <th>Price</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.project?.name || ''}</td>
                <td>{r.orderNumber}</td>
                <td>{r.orderDate || ''}</td>
                <td>{r.package?.name || ''}</td>
                <td>{r.status}</td>
                <td>{r.totalQuantity}</td>
                <td>{nf.format(r.totalPrice || 0)}</td>
                <td>
                  <button className="eduss-global-action-btn view" onClick={()=>fetchDetail(r.id)}>View</button>
                </td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center' }}>
                  No work orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {viewRow && (
        <div
          className="eduss-global-modal-overlay"
          onClick={() => setViewRow(null)}
        >
          <div
            className="eduss-global-modal eduss-admin-form-modal"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: 1000 }}
          >
            <div className="eduss-global-modal-header">
              <h3>Work Order Details</h3>
              <button onClick={() => setViewRow(null)}>&times;</button>
            </div>
            <div
              className="eduss-global-modal-content"
              style={{ maxHeight: '70vh', overflowY: 'auto' }}
            >
              <table className="eduss-global-view-table">
                <tbody>
                  <tr>
                    <th>Project</th>
                    <td>{viewRow.project?.name || ''}</td>
                  </tr>
                  <tr>
                    <th>Order #</th>
                    <td>{viewRow.orderNumber}</td>
                  </tr>
                  <tr>
                    <th>Order Date</th>
                    <td>{viewRow.orderDate}</td>
                  </tr>
                  <tr>
                    <th>Package</th>
                    <td>{viewRow.package?.name || ''}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{viewRow.status}</td>
                  </tr>
                  <tr>
                    <th>Total Qty</th>
                    <td>{viewRow.totalQuantity}</td>
                  </tr>
                  <tr>
                    <th>Total Price</th>
                    <td>{nf.format(viewRow.totalPrice || 0)}</td>
                  </tr>
                  <tr><th colSpan={2}>Books</th></tr>
                  <tr>
                    <td colSpan={2}>
                      <table className="eduss-global-datatable" style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th>Code</th><th>Name</th><th>Quantity</th><th>Unit Price</th><th>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {viewRow.items?.map((it,i)=>(
                            <tr key={i}><td>{it.code}</td><td>{it.name}</td><td>{it.quantity}</td><td>{nf.format(it.unitPrice)}</td><td>{nf.format(it.quantity*it.unitPrice)}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}
